export default {
  signUpSuccess: 'Succesfully registered! You\'ve been signed in as well.',
  signUpFailure: 'Registration failed. Email may be taken, or passwords don\'t match.',
  signInSuccess: 'Welcome!',
  signInFailure: 'Failed to sign in. Check your email and password and try again.',
  signOutSuccess: 'Come back soon!',
  changePasswordSuccess: 'Password changed successfully!',
  changePasswordFailure: 'Failed to change passwords. Check your old password and try again.',
  postCreatedSuccess: '👍',
  postCreatedFailure: 'Please fill out all forms 😩',
  postEditSuccess: '',
  postEditFailure: 'Only creator can edit this post',
  postIndexFailure: 'Oops... Try again',
  postDeleteSuccess: 'Start a new post! 📝',
  postDeleteFailure: 'Only creator can delete this post',
  commentCreateSuccess: '👍',
  commentCreateFailure: 'Please fill out form 😩',
  commentEditSuccess: '',
  commentEditFailure: 'Only creator can edit this comment',
  commentDeleteSuccess: 'Comment on more posts!',
  commentDeleteFailure: 'Only creator can delete this comment'
}



// WEBPACK FOOTER //
// ./src/components/AutoDismissAlert/messages.js